



































































































import _ from 'lodash';
import numeral from 'numeral';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { httpService, i18nService } from '@/services';
import { AxiosResponse } from 'axios';

import { CONFIG } from '@/config';
import * as moment from 'moment';
import { ReportEnum } from '../../model/types/enums/reportEnum';
import { Period } from '@/modules/neodash/model/types/interfaces/Period';
import { GET_PERIOD } from '@/modules/neodash/store/modules/reports/types';
import { i18nMixin } from '@/modules/neodash/mixins';
import { NameValue } from '../../model/types/interfaces/NameValue';

@Component({
  name: 'RegistrationByBrandReport',
  components: {}
})
export default class RegistrationByBrandReport extends Vue {
  numeral = numeral;
  public translate = i18nMixin.methods.i18n;

  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  @Prop({ required: true })
  public dataQuery: any;

  public yearsHead: number[];
  public monthInit: string;
  public monthLast: string;
  public tipoReport: string;
  public tituloLocalidade: string;
  public dateAtualDescription: string = `${i18nService.i18n('Common.ActualDate')}: ` + moment(new Date()).format('DD/MM/YYYY');

  public state: any = {
    dataSource: [],
    total: {},
    requestData: {},
    client: ''
  };

  @Watch('dataQuery')
  public requestData() {
    this.state.requestData = {
      TypeLocality: this.dataQuery.resolutionLevel.value[0],
      YearLast: this.dataQuery.ano.value,
      MonthInit: this.dataQuery.mes_inicial.value,
      MonthLast: this.dataQuery.mes_final.value,
      GeoCodigos: this.dataQuery.localidades.value,
      VirtualAreaType: this.dataQuery.virtualAreaType ? this.dataQuery.virtualAreaType.value[0] : 0,
      TypeLicensePlate: this.dataQuery.tipo_emplacamento.value,
      IdsCompanySize: this.dataQuery.idsCompanySize.value,
    };
    this.monthInit = this.dataQuery.mes_inicial.name.substring(0, 3);
    this.monthLast = this.dataQuery.mes_final.name.substring(0, 3);
    const {
      initial: { year }
    } = this.getPeriod(ReportEnum.RegistrationByBrandAndSegment);

    this.yearsHead = _.range(this.state.requestData.YearLast - 3, this.state.requestData.YearLast + 1);
    this.tipoReport =
      this.dataQuery.tipo_emplacamento.value === 1
        ? 'RETAIL'
        : this.dataQuery.tipo_emplacamento.value === 2
        ? 'DIRECT SALES'
        : 'TOTAL';
    this.tituloLocalidade =
      this.dataQuery.localidades.text.length === 1 ? this.dataQuery.localidades.text[0].toUpperCase() + ' -' : '';

    httpService.http
      .post(`${CONFIG.URL.NEODASH_API}/api/gigdashfilters/getDSRegistrationByBrand`, this.state.requestData)
      .then((res: AxiosResponse) => {
        this.state.client = res.data ? res.data.nameClient : '';
        this.state.dataSource = _(res.data.registration)
          .groupBy((d: any) => d.nome_bandeira)
          .map((d: any) => {
            this.yearsHead
              .filter((f: any) => !d.some((vl: any) => f === vl.ano) && f.nome_bandeira != '')
              .forEach(value => {
                d.push({ nome_bandeira: d[0].nome_bandeira, ano: value, emplac_bnd: 0 });
              });

            return _.orderBy(d, 'ano');
          })
          .orderBy((d: any) => -d[d.length - 1].emplac_bnd)
          .value();

        this.state.total = this.state.dataSource
          .reduce((acc, curr) => {
              curr.forEach(x => acc[x.ano] = isNaN(parseInt(acc[x.ano]))
                  ? x.emplac_bnd
                  : acc[x.ano] + x.emplac_bnd)
              return acc;
          }, {});

        if (this.state.dataSource.some((f: any) => f[0].nome_bandeira.toUpperCase() === 'OUTROS')) {
          var outros = this.state.dataSource.filter((f: any) => f[0].nome_bandeira.toUpperCase() === 'OUTROS')[0];
          _.remove(this.state.dataSource, function(n: any) {
            return n[0].nome_bandeira.toUpperCase() === 'OUTROS';
          });
          this.state.dataSource.push(outros);
        }
      });
  }

  public created() {
    this.requestData();
  }
}
